import { useBbContentPresenter } from '@Components/BigBrowse/bb2/BbContentPresenter';
import OwnableTheme from '@Theme';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { Pressable, StyleSheet } from 'react-native';

import { MiniMapError } from './HelperComponents/MiniMapError';
import { MiniMapErrorBoundary } from './HelperComponents/MiniMapErrorBoundary';
import { MiniMapLoading } from './HelperComponents/MiniMapLoading';
import { MiniMapLayout } from './MiniLayouts/MiniMapLayout/MiniMapLayout';
import { MiniShopFloor } from './MiniLayouts/MiniShopFloor/MiniShopFloor';
import { useMiniMap2Presenter } from './MiniMap2Presenter';
import { useMiniMapWrapperStyle } from './useWrapperStyles';
import { Hoverable } from 'react-native-web-hooks';
import { Motion } from '@legendapp/motion';

type Props = {
  onClickOverride?: () => void;
};

export const MiniMap2 = observer(function MiniMap2({ onClickOverride }: Props) {
  const { isFetching, showMapLayout, showShopFloor, showError, onMapClick } =
    useMiniMap2Presenter();

  const contentPresenter = useBbContentPresenter();

  const dynamicStyle = useMiniMapWrapperStyle();
  const floorId = contentPresenter.journeyParams?.journeyParam;
  return (
    <Hoverable>
      {(isHovered) => (
        <Motion.View
          style={[styles.wrapper, dynamicStyle]}
          animate={{ scale: isHovered ? 1.05 : 1 }}
        >
          <MiniMapErrorBoundary>
            {isFetching && <MiniMapLoading />}
            {showError && <MiniMapError />}
            {showMapLayout && floorId && <MiniMapLayout floorId={floorId} />}
            {/* TODO: investigate what is this MiniShopFloor?*/}
            {showShopFloor && <MiniShopFloor />}
          </MiniMapErrorBoundary>
          <Pressable
            onPress={onClickOverride ?? onMapClick}
            style={StyleSheet.absoluteFill}
          />
        </Motion.View>
      )}
    </Hoverable>
  );
});

export const MINI_MAP_BOTTOM_POSITION = 20;

const styles = StyleSheet.create({
  wrapper: {
    position: 'absolute',
    bottom: MINI_MAP_BOTTOM_POSITION,
    left: 20,
    paddingVertical: 6,
    paddingHorizontal: 8,
    borderRadius: 15,
    backgroundColor: OwnableTheme.colors.white,
    alignItems: 'center',
    justifyContent: 'center',
    shadowColor: OwnableTheme.colors.black,
    shadowOpacity: 0.25,
    shadowRadius: 25,
  },
});
